import { mapEnumToOptions } from '@abp/ng.core';

export enum AgentApiKeyType {
  Module = 1,
  Agent = 2,
}

export const agentApiKeyTypeOptions = mapEnumToOptions(AgentApiKeyType);
